/**
 * @module websocket.event.handlers.passengers.passenger-added
 */
import { store } from '../../../../state/store'
import { setPassengerListUpdated } from '../../../../state/websocket.slice'

export default function handlePassengerAdded(context) {
  const { payload: { channelId, data } = {} } = context
  if (!data || !channelId) {
    return
  }

  const isSubscribed = store
    .getState()
    ?.websocket?.subscriptions?.some((channel) => channel === channelId)

  console.log('#handlePassengerAdded', {
    isSubscribed,
    channelId,
    data,
  })

  if (isSubscribed) {
    store.dispatch(setPassengerListUpdated(data))
  }
}
